var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderComponent)?_c('v-combobox',{attrs:{"outlined":"","items":_vm.items,"item-text":"text","label":_vm.label,"persistent-hint":"","return-object":"","clearable":""},on:{"input":_vm.handleInput},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }